export class Sponsor {
    
    public id: string = '0';
    public name: string;   
    public url: string;   
    public image: string;   
    
    constructor() {}
}